import { callExternalApi } from './external-api.service'
import API_PATHS from '../constants/API_PATHS'

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL

export const svc_createTransaction = async (accessToken, userId, transaction) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_TRANSACTION(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: transaction,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_createException = async (accessToken, userId, exception) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_EXCEPTION(
            userId,
            exception.transactionId
        )}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: exception,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getExceptions = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_EXCEPTIONS(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getExceptionsByTransactionId = async (
    accessToken,
    userId,
    transactionId
) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_EXCEPTIONS_BY_TRANSACTION_ID(
            userId,
            transactionId
        )}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getTransactions = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_TRANSACTIONS(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getException = async (
    accessToken,
    userId,
    exceptionId
) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_EXCEPTION(
            userId,
            exceptionId
        )}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getTransaction = async (accessToken, userId, transactionId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_TRANSACTION(userId, transactionId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_createSnowballData = async (accessToken, userId, snowballData) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_SNOWBALL_DATA(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: snowballData,
        // data: JSON.stringify(snowballData),
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getSnowballData = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_SNOWBALL_DATA(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        }
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}


export const svc_getSnowballTransactionIds = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_SNOWBALL_TRANSACTION_IDS(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteSnowballTransactions = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_SNOWBALL_TRANSACTIONS(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_updateTransaction = async (accessToken, userId, transaction) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.UPDATE_TRANSACTION(userId, transaction.id)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: transaction,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_setTransactionAccountToNullByAccountId = async (
    accessToken,
    userId,
    accountId
) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.SET_TRANSACTION_ACCOUNT_TO_NULL_BY_ACCOUNT_ID(
            userId,
            accountId
        )}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteTransactionPattern = async (accessToken, userId, transactionId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_TRANSACTION_PATTERN(userId, transactionId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteTransaction = async (accessToken, userId, transactionId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_TRANSACTION(userId, transactionId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteException = async (
    accessToken,
    userId,
    exceptionId,
    exceptionData
) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_EXCEPTION(userId, exceptionId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: exceptionData,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteAllExceptionsByTransactionId = async (
    accessToken,
    userId,
    transactionId
) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_ALL_EXCEPTIONS_BY_TRANSACTION_ID(
            userId,
            transactionId
        )}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getTransactionTemplates = async (accessToken) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_TRANSACTION_TEMPLATES()}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}